<template>
  <!-- 화면 공통 페이징 위젯:
       중앙 = 맨앞 이전 1 2 3 4 5 다음 맨뒤
       우측 = 10/20/30/40/50 콤보박스 (로딩 시 기본 10) -->
  <div class="paging-bar">
    <div class="paging-center">
      <a href="javascript:;" :class="{disabled: page<=1}" @click="go(1)">맨앞</a>
      <a href="javascript:;" :class="{disabled: page<=1}" @click="go(page-1)">이전</a>
      <a v-for="p in pageNumbers" :key="p" href="javascript:;"
         :class="{active: p===page}" @click="go(p)">{{ p }}</a>
      <a href="javascript:;" :class="{disabled: page>=totalPages}" @click="go(page+1)">다음</a>
      <a href="javascript:;" :class="{disabled: page>=totalPages}" @click="go(totalPages)">맨뒤</a>
    </div>
    <div class="paging-right">
      <span class="total">총 {{ totalCount }}건</span>
      <select :value="size" @change="onSize($event)">
        <option v-for="s in sizeOptions" :key="s" :value="s">{{ s }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paging',
  props: {
    page: { type: Number, default: 1 },
    size: { type: Number, default: 10 },
    totalCount: { type: Number, default: 0 },
    totalPages: { type: Number, default: 0 },
    blockSize: { type: Number, default: 5 } // 한 번에 보이는 페이지 번호 개수(1 2 3 4 5)
  },
  data() {
    return { sizeOptions: [10, 20, 30, 40, 50] };
  },
  computed: {
    pageNumbers() {
      const tp = Math.max(this.totalPages, 1);
      const block = Math.trunc((this.page - 1) / this.blockSize);
      const start = block * this.blockSize + 1;
      const end = Math.min(start + this.blockSize - 1, tp);
      const arr = [];
      for (let i = start; i <= end; i++) arr.push(i);
      return arr;
    }
  },
  methods: {
    go(p) {
      const tp = Math.max(this.totalPages, 1);
      if (p < 1 || p > tp || p === this.page) return;
      this.$emit('change-page', p);
    },
    onSize(e) {
      const s = parseInt(e.target.value, 10);
      this.$emit('change-size', s);
    }
  }
};
</script>

<style scoped>
.paging-bar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 14px 0;
  min-height: 34px;
}
.paging-center { display: flex; gap: 4px; align-items: center; }
.paging-center a {
  display: inline-block;
  min-width: 30px;
  padding: 5px 9px;
  border: 1px solid #d0d5dd;
  border-radius: 5px;
  text-decoration: none;
  color: #333;
  font-size: 13px;
  text-align: center;
}
.paging-center a.active { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.paging-center a.disabled { color: #bbb; pointer-events: none; background: #f5f5f5; }
.paging-right {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.paging-right .total { font-size: 12px; color: #666; }
.paging-right select { padding: 5px 8px; border: 1px solid #d0d5dd; border-radius: 5px; }
</style>
